import React from 'react'
import { ActiveBalanceFilter } from '../activeBalanceFilter'
import { Card, Flex, Table, TableColumnsType, Tooltip, Typography } from 'antd'
import styles from './styles.module.css'
import { $activeBalances, getActiveBalances } from './model'
import { useStore } from 'effector-react'
import { DataType } from './types'
import { mapActiveBalances } from './utils'
import { $activeBalanceFilter } from '../activeBalanceFilter/model'
import { getFinsystemNumberFormat } from '../../../../../libs/utils'

const columns: TableColumnsType<DataType> = [
  {
    title: '',
    dataIndex: 'name',
    key: 'name',
    width: '35%',
  },
  {
    title: '',
    dataIndex: 'wallet',
    key: 'wallet',
    width: '35%',
  },
  {
    title: '',
    dataIndex: 'result',
    key: 'result',
    width: '30%',
    align: 'right',
  },
]

export const ActiveBalances: React.FC = () => {
  const activeBalances = useStore($activeBalances)
  const isLoading = useStore(getActiveBalances.pending)
  const { paymentSystem } = useStore($activeBalanceFilter)

  if (!activeBalances) {
    return <div>Active balances not found</div>
  }

  return (
    <Card className={styles.activeBalances}>
      <Flex gap={24} vertical>
        <Typography.Title level={4}>Active</Typography.Title>
        <ActiveBalanceFilter />

        <Tooltip title="Начальный остаток на всех кошельках по курсу на начало периода">
          <Flex justify="space-between" className={styles.openingBalance}>
            <div>Opening balance</div>
            <div>
              {getFinsystemNumberFormat(activeBalances.openingBalance, 2)}
            </div>
          </Flex>
        </Tooltip>

        <Table
          className="overflow-auto"
          columns={columns}
          loading={isLoading}
          dataSource={mapActiveBalances(activeBalances, paymentSystem)}
          pagination={false}
          rowClassName={(record) =>
            record.key === 7 || record.key === 8
              ? styles.activeFooterRows
              : record.shouldBeGray
              ? styles.lightGrayRow
              : styles.activeBalancesRows
          }
        />
      </Flex>
    </Card>
  )
}
